<template>
  <div
    v-if="datas && datas.length"
    class="mb-5"
    :class="{ 'section-loading': isLoading }"
  >
    <div class="box" :class="className.sectionBlock"></div>
    <span class="font-20">
      <strong>{{ title }}</strong>
      <a
        @click="detailToggle(isShow)"
        role="button"
        class="btn btn-icon btn-sm btn-collapse mt-0"
        :class="isShow ? 'btn-primary' : 'btn-default'"
      >
        <i :class="isShow ? 'icon-collapse_up' : 'icon-collapse_down'"></i>
      </a>
     <span
        v-if="isShow && isShowMemo"
        class="text-red text-bold font-16"
        ><br />以下為投保當時的保單資訊，僅供參考，實際保障內容請以最新保單、批單所載資訊為準。</span
      >
    </span>
    <section v-if="isShow" class="newTable">
      <slot
        :theme="theme"
        :datas="datas"
        :_fields="_fields"
        :constantSortKey="constantSortKey"
        :constantSortType="constantSortType"
        :initSort="initSort"
      ></slot>
    </section>
  </div>
</template>

<script>
import HardwordMixins from "@/mixins/Hardword";

export default {
  mixins: [HardwordMixins],
  props: {
    title: {
      type: String,
      required: true,
    },
    theme: {
      type: String,
      required: true,
    },
    datas: {
      type: Array,
      required: true,
    },
    _fields: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    constantSortKey: Array,
    constantSortType: Array,
    initSort: Object,
    initShow: { type: Boolean, default: true },
    isHurtInsurance: { type: Boolean, default: false },
    isHealthInsurance: { type: Boolean, default: false },
    isCarInsurance: { type: Boolean, default: false },
    isFireInsurance: { type: Boolean, default: false },
    isNewInsurance: { type: Boolean, default: false },
  },
  hardwroldWatcher: ["datas"],
  data() {
    return { isShow: this.initShow };
  },
  methods: {
    detailToggle(val) {
      this.isShow = !val;
      this.$emit("toggle", this.isShow);
    },
  },
  computed: {
    className() {
      switch (this.theme) {
        case "red":
          return {
            sectionBlock: "boxRed",
          };
        case "blue":
          return {
            sectionBlock: "boxBlue",
          };
        case "green":
          return {
            sectionBlock: "boxGreen",
          };
      }
    },
    isShowMemo() {
      return this.isHurtInsurance || this.isHealthInsurance || this.isCarInsurance || this.isFireInsurance || this.isNewInsurance;
    }
  },
};
</script>

<style scoped>
.box {
  float: left;
  height: 24px;
  width: 8px;
  margin-right: 8px;
  clear: both;
}
.boxGreen {
  background-color: #027a39;
}
.boxBlue {
  background-color: #007ab1;
}
.boxRed {
  background-color: #de4054;
}
</style>
